/**
 * Ai Assistant Sandbox API
 * AI Assistant POC
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Unknown, 1 = Developer, 2 = System, 3 = Assistant, 4 = User, 5 = Tool
 */
export enum ChatMessageAuthorRoles {
    Unknown = 'unknown',
    Developer = 'developer',
    System = 'system',
    Assistant = 'assistant',
    User = 'user',
    Tool = 'tool'
}

